// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import iView from "iview";
import i18n from "./libs/vuei18n.js";
import "iview/dist/styles/iview.css";
import vueLoading from "./libs/loadingOverlay.js";
import "@/css/index.less";
import http from "@/js/http.js";
import until from "@/js/until.js";
import countriesBox from "@/components/countriesBox/countriesBox.vue"; //全局注册多选区域国家组件
import showMoreBox from "@/components/showMore/showMore.vue"; //全局注册多选区域国家组件
import Dialog from "@/components/globalDialog/globalDialog.js"; //全局提示弹窗
import regionSelect from "@/components/regionSelect/regionSelect.vue";
import musicPlayer from "@/components/musicPlayer/MusicPlayer.vue";

import dictionary from "@/js/dictionary.js";
import config from "@/config";
import store from "./store";
import localStore from "store";

import VideoPlayer from "vue-video-player";
import "vue-video-player/src/custom-theme.css";
import "video.js/dist/video-js.css";

import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard)
Vue.use(VideoPlayer);
Vue.use(Dialog);
Vue.component("countriesBox", countriesBox);
Vue.component("showMoreBox", showMoreBox);
Vue.component("regionSelect", regionSelect);
Vue.component("musicPlayer", musicPlayer);

Vue.prototype.$numberWithCommas = until.numberWithCommas
Vue.prototype.$http = http;
Vue.prototype.$config = config;
Vue.prototype.$dictionary = dictionary;
Vue.prototype.$selfGlobal = {
  $globalStore: store,
  $globalI18n: i18n,
  $globalRequestMeth: {
    request: true,
    methodList: []
  },
  checkBanLength: 5, // 封禁操作0个会出提示框
  $globalMethodArr: [], // 需要另外执行的方法可以推入该数组(封禁时操作用户信息用的)
};
until.phoneType() == "PC" ? until.websiteAdaptive() : until.adaptive();

Vue.prototype.$localStore = localStore;

Vue.config.productionTip = false;
Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
});

Vue.prototype.$globalMethods = {
  checkBanShowModal(checkLength, method, type='checkbox',selfCheckLength = 0) {
    const selfGlobal = this.$selfGlobal;
    const showBanOperatFlag = this.$store.state.app.showBanOperatFlag;
    const checkBanLength = selfCheckLength ? selfCheckLength : selfGlobal.checkBanLength;
    if (checkLength >= checkBanLength && !showBanOperatFlag.show) {
      this.$store.commit('setShowBanOperatFlag', {
        show: true,
        count: checkLength,
        type: 'checkbox',
      });
      selfGlobal.$globalMethodArr.push({
        method,
        that: this,
      });
      return false;
    } else if (type === 'submit' && !showBanOperatFlag.show) {
      this.$store.commit('setShowBanOperatFlag', {
        show: true,
        count: 30,
        type: 'submit',
      });
      selfGlobal.$globalMethodArr.push({
        method,
        that: this,
      });
      return false;
    }
    return true;
  },
}

// // // // 全局确认对话框
let modalCon = function (text) {
  if (document.querySelector("#notice-1")) {
    return new Promise(resolve => {
      resolve(false);
    });
  }
  return this.$globalDialog({
    title: this.$i18n.tc("views.public.prompt"),
    okText: this.$i18n.tc("views.public.sure"),
    cancelText: this.$i18n.tc("views.public.cancel"),
    content: text,
    showIcon: true
  });
};

// // // // 显示更多
let showMore = function (text) {
  if (document.querySelector("#notice-1")) {
    return new Promise(resolve => {
      resolve(false);
    });
  }
  return this.$globalDialog({
    title: this.$i18n.tc("views.public.more"),
    okText: this.$i18n.tc("views.public.sure"),
    cancelText: this.$i18n.tc("views.public.cancel"),
    content: text,
    showIcon: false
  });
};

// // // // 全局确认对话框
// let modalCon = function (text) {
//   console.log("回车触发")
//   return new Promise((resolve, reject) => {
//     this.$Modal.confirm({
//       title: this.$i18n.tc('views.public.prompt'),
//       okText: this.$i18n.tc('views.public.sure'),
//       cancelText: this.$i18n.tc('views.public.cancel'),
//       content: text,
//       closable:true,
//       onOk: () => {
//         resolve(true)
//       },
//       onCancel: () => {
//         resolve(false)
//       }
//     })
//   })
// }

// 获取权限设置 鉴权
let getauth = function (id) {
  let list = JSON.parse(localStorage.getItem("authList")) || [];
  // console.log('logic',list)
  if (list.length === 0 ){
    return true
  }
  let data = false;
  list.forEach(item => {
    if (Number(item) == id) {
      data = true;
    }
  });
  return data;
};
//设置 “国家区域” 的选项
let getglobalRegion = function (type, boolean = true) {
  let text = null;
  let list = [
    {id: 0, text: this.$i18n.t("countryManagement.language_en")},
    {id: 1, text: this.$i18n.t("countryManagement.language_ar")},
    {id: 3, text: this.$i18n.t("countryManagement.language_tr")},
    {id: 4, text: this.$i18n.t("countryManagement.language_hi")},
    {id: 5, text: this.$i18n.t("countryManagement.language_vi")},
    {id: 6, text: this.$i18n.t("countryManagement.language_th")},
    {id: 9, text: this.$i18n.t("countryManagement.language_es")},
    {id: 10, text: this.$i18n.t("countryManagement.language_in_id")},
    {id: 11, text: this.$i18n.t("countryManagement.language_pt")},
    {id: 12, text: this.$i18n.t("countryManagement.language_india")}
  ];
  if (boolean) {
    list.unshift({id: -1, text: this.$i18n.t("countryManagement.country_all")},)
  }
  list.forEach(item => {
    if (Number(type) == Number(item.id)) {
      text = item.text;
    }
  });
  return type ? text : text || list;
};

function getLocal(type) {
  return JSON.parse(localStorage.getItem(type));
}

function setLocal(type, value) {
  localStorage.setItem(type, JSON.stringify(value));
}

function removeLocal(type) {
  localStorage.removeItem(type);
}

function setCountryName(type, Boolean = false) {
  let list = getLocal("countriesList");
  let results = [];
  let nameList = [];
  if (Array.isArray(type)) {
    for (let i in type) {
      results.push(list.find(item => item.id == type[i]));
    }
  } else {
    results.push(list.find(item => item.id == type));
  }

  if (Boolean) {
    return results;
  } else {
    results.forEach(item => {
      if (item) {
        nameList.push(item.country_name);
      }
    });
    return nameList.join();
  }
}

function interfaceRegional(msg = {region: undefined, noList: undefined,noInt:false}) {
  // return  []
  // region  获取区域名称
  // noList  需要过滤的区域
  // noInt  转字符串
  const {region, noList,noInt} = msg;

  let list = getLocal("interfaceRegional");
  if(noInt){
    list.forEach((item)=>{
      item.id=item.id+''
    })
  }
  let newArray = []

  let results = [];
  let nameList = [];
  if (Array.isArray(region)) {
    for (let i in region) {
      results.push(list.find(item => item.id === Number(region[i])));
    }
  } else {
    let reg=region+''
    results.push(list.find(item => item.id === Number(reg)));
  }
  results.forEach(item => {
    if (item) {
      nameList.push(item.text);
    }
  });

  if (Array.isArray(noList)) {
    list.forEach((item) => {
      if (!noList.includes(Number(item.id))) {
        newArray.push(item)
      }
    })
  }
  return region!==undefined? nameList.join() : Array.isArray(noList) ? newArray : list;

}

// 深拷贝方法
function copyMsg(msg) {
  return JSON.parse(JSON.stringify(msg))
}

function getAuthCountry() {
  // console.log('created')
  let countryList = this.getLocal("countriesList")

  let thisRoute = this.$route
  // console.log(thisRoute)
  let list = []
  switch (thisRoute.meta.id) {
    case 334:
      this.setLocal('authCountry','[10000]')
      return '[10000]'
    // break;
    case 335:
      countryList.forEach(e=>{
        if (e.region === 1){
          list.push(e.id)
        }
      })
      this.setLocal('authCountry',JSON.stringify(list))
      break;
    case 336:
      countryList.forEach(e=>{
        if (e.region === 2){
          list.push(e.id)
        }
      })
      this.setLocal('authCountry',JSON.stringify(list))
      break;
    case 337:
      countryList.forEach(e=>{
        if (e.region === 3){
          list.push(e.id)
        }
      })
      this.setLocal('authCountry',JSON.stringify(list))
      break;
    default:
      this.setLocal('authCountry','')
      return ''
  }

  return JSON.stringify(list)
}

Vue.prototype.$copyMsg = copyMsg;
Vue.prototype.$modalCon = modalCon;
Vue.prototype.getauth = getauth;
Vue.prototype.getglobalRegion = getglobalRegion;
Vue.prototype.getLocal = getLocal;
Vue.prototype.setLocal = setLocal;
Vue.prototype.removeLocal = removeLocal;
Vue.prototype.$setCountryName = setCountryName;
Vue.prototype.$showMore = showMore;
Vue.prototype.$interfaceRegional = interfaceRegional;
Vue.prototype.$getAuthCountry = getAuthCountry;
Vue.prototype.$numberWithCommas = until.numberWithCommas;
Vue.prototype.$scientificToNumber = until.scientificToNumber;

/* eslint-disable no-new */
// if (window.top.location.href.indexOf('localhost') < 0){

import FingerprintJS from '@/js/fingerprintjsv4'
FingerprintJS.load().then(fp => fp.get()).then(result => {
  // console.log('visitorId',result.visitorId)
  // 判断是否能打开页面
  const xhr = new XMLHttpRequest();
//?block=1是测试模拟401错误
  let url =  `https://short.faceline.live/cn?h5imei=${result.visitorId}` // 'https://short.faceline.live/cn?block=1'  //
  xhr.open('GET', url);
  xhr.onload = () => {
    if (xhr.status === 200) {
      console.log('status200',xhr.responseText);
      // 成功后new Vue
      new Vue({
        el: "#app",
        router,
        store,
        i18n,
        components: {App},
        template: "<App/>"
      });
    }else {
      console.log('error');
      location.href = 'https://www.google.com';
    }
  };
  xhr.onerror = () =>{
    location.href = 'https://www.google.com';
    // setTimeout(()=>{
    //   location.href = 'https://www.google.com';
    // },5000)
  };
  xhr.send();
});
// ================ 使用示例 ================
// console.log('Canvas Fingerprint:', getCanvasFingerprint());
// 示例输出（每次在同一台设备同一浏览器基本不变）:
// Canvas Fingerprint: e79dbe6e







// WEBPACK FOOTER //
// ./src/main.js